import { queryClient } from '../api/queryClient'

// ── Обновление «Очереди квот» без наслоения загрузок ─────────────────────
//
// Очередь — самая тяжёлая выборка сайта: до 1000 позиций за порцию, а при
// прокрутке перезагружаются все открытые порции. Раньше её сбрасывали через
// 150 мс после каждого чужого действия, и сброс обрывал начатую загрузку —
// браузер начинал новую, а сервер дособирал брошенную. 22.10.2026 так за 5 минут
// пришло 73 загрузки по 20–25 с, api упёрся в лимит памяти и перезапустился.
//
// Теперь:
// 1) новая загрузка не стартует, пока идёт прежняя (ждём и пробуем снова);
// 2) чужие изменения собираются в одно обновление раз в QUEUE_REMOTE_DELAY_MS.
// Свои действия обновляют очередь сразу (refreshQueueNow), но тоже не поверх
// идущей загрузки.

const QUEUE_KEY = ['procurement', 'queue']
export const QUEUE_REMOTE_DELAY_MS = 5000
const BUSY_RETRY_MS = 1000

let timer: ReturnType<typeof setTimeout> | null = null

function flush(): void {
  timer = null
  if (queryClient.isFetching({ queryKey: QUEUE_KEY }) > 0) {
    timer = setTimeout(flush, BUSY_RETRY_MS)
    return
  }
  void queryClient.invalidateQueries({ queryKey: QUEUE_KEY }, { cancelRefetch: false })
}

/** Чужое изменение (живое событие): одно обновление очереди на окно в 5 с. */
export function scheduleQueueRefresh(): void {
  if (timer) return
  timer = setTimeout(flush, QUEUE_REMOTE_DELAY_MS)
}

/** Своё действие: обновить очередь сразу, но не поверх идущей загрузки. */
export function refreshQueueNow(): void {
  if (timer) clearTimeout(timer)
  flush()
}

/** Снять отложенное обновление (выход, отключение живых событий). */
export function cancelQueueRefresh(): void {
  if (timer) clearTimeout(timer)
  timer = null
}
